// extracted by mini-css-extract-plugin
module.exports = {"footerText":"eW8f8P","text":"_3MDT-E","button":"_3PZcFn"};